import { ICON_STYLES, ICON_STYLE_DEFAULT, IconType } from '../constants/icon';

export const getIconStyle = (iconType: IconType) => {
  if (iconType === 'BRAND') {
    return ICON_STYLES.BRAND;
  }

  return ICON_STYLE_DEFAULT;
};
